import styles from "./rightButtons.module.scss";
import CheckIcon from '@mui/icons-material/Check';

const RightButtons = ({
    onShare = () => {}, 
    onTransfer = () => {}, 
    onDelete = () => {},
    onCertificate = () => {},
    publication,
    user
}: any) => {
    return (
        <div className={styles.rightButtons}>
            {
                user?.profile?.code !== "seller" &&
                <>
                    <p className={styles.button} onClick={() => !publication?.certified ? onCertificate() : {}}>
                        { !publication?.certified ? "Verificar" : "Verificado" }
                        { publication?.certified && <CheckIcon className={styles.successIcon} /> }
                    </p>
                    <div className={styles.separator}/>
                </>
            }
            <p className={styles.button} onClick={onShare}>Compartir</p>
            <div className={styles.separator}/>
            <p className={styles.button} onClick={onTransfer}>Transferir</p>
            <div className={styles.separator}/>
            <p className={styles.button} onClick={onDelete}>Eliminar</p>
        </div>
    );
}

export default RightButtons;